module.exports = __webpack_public_path__ + "static/media/image5.20b9f0a9.jpeg";